module.exports = __webpack_public_path__ + "img/team-5.56332143.jpg";